import { get } from 'lodash';
import { createPropsSelectorOrm } from '../utils';

export const getCollectionActionsByDepotCode = createPropsSelectorOrm(
  (session, collectionCode) => get(session.Action.withId(collectionCode), 'ref')
);
